import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';

const NoPairsState = ({ Icon, title, description }) => {
  const theme = useTheme();
  return (
  <Box
    sx={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      p: 4,
    }}
  >
    <Box
      sx={{
        width: 80,
        height: 80,
        borderRadius: '50%',
        bgcolor: alpha(theme.palette.primary.main, 0.1),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Icon sx={{ fontSize: 36, color: 'primary.main', opacity: 0.7 }} />
    </Box>
    <Typography
      variant="h6"
      sx={{
        fontWeight: 600,
        color: 'text.primary',
        textAlign: 'center',
      }}
    >
      {title}
    </Typography>
    <Typography
      variant="body2"
      sx={{
        color: 'text.secondary',
        textAlign: 'center',
        maxWidth: 300,
      }}
    >
      {description}
    </Typography>
  </Box>
  );
};

export default NoPairsState;
